<template>
	<span class="tag" :class="`bg-${color}`">
		{{ title }}
	</span>
</template>
<script>
export default {
	name: 'PropertyTag',
	props: {
		title: String,
		color: {
			type: String,
			default: 'black',
		},
	}
}
</script>
<style lang="scss" scoped>
.tag {
	display: inline-block;
	height: 24px;
	padding: 2px 8px;
	border-radius: 4px;

	font-size: 14px;
	line-height: 20px;

	font-family: var(--font-family-bold);

	a > & {
		margin-left: 8px;
	}

	&.bg {
		&-black {
			color: var(--primary-white);
			background: var(--primary-black);
		}
	}
}

</style>